export default __webpack_public_path__ + "static/media/not-active.e22d1886.svg";